<ion-app>
    <ion-router-outlet id='main'></ion-router-outlet>
    <ion-menu contentId='main' id='mainMenu' side='start'>
        <ion-header mode='md'>
            <ion-toolbar>
                <ion-title>{{'app.menu'|translate}}</ion-title>
            </ion-toolbar>
        </ion-header>
        <ion-content [scrollY]='false'>
            <ion-list mode='md'>
                <ng-container *ngFor='let p of pages;let i = index'>
                    <ion-item mode='md'
                              [lines]="p.lines"
                              *ngIf='!router.url.includes(p.route)'
                              (click)='p.route ? openPage(p, i) : p.action()'>
                        <ion-icon slot='start' [name]='p.icon'></ion-icon>
                        {{p.title}}
                    </ion-item>
                </ng-container>
            </ion-list>
        </ion-content>
    </ion-menu>
</ion-app>
